module.exports = __webpack_public_path__ + "img/calendar.335c1670.svg";